export default __webpack_public_path__ + "static/media/lacessories2.dc993ff3.jfif";